import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "schema"],
    _excluded2 = ["schema", "dataset", "filteredDataset", "rowCount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ProductTable from './product-table';
import HTMLTable from './product-table-html';
import sw from '@uswitch/ev-utils/switch';
import { useEntity } from '@uswitch/ev-utils/context/selectors';
import { isEmpty } from '@uswitch/ev-utils/obj';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var VariantTable = function VariantTable(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'rich' : _ref$variant,
      schema = _ref.schema,
      props = _objectWithoutProperties(_ref, _excluded);

  return sw({
    html: function html() {
      return _jsx(HTMLTable, _objectSpread({}, props));
    },
    card: function card() {
      return _jsx(ProductTable, _objectSpread(_objectSpread({}, props), {}, {
        card: true
      }, schema));
    },
    default: function _default() {
      return _jsx(ProductTable, _objectSpread(_objectSpread({}, props), schema));
    }
  })(variant.toLowerCase(), props);
};

var PT = function PT(_ref2) {
  var schema = _ref2.schema,
      dataset = _ref2.dataset,
      filteredDataset = _ref2.filteredDataset,
      rowCount = _ref2.rowCount,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var datasetEntity = useEntity(dataset);
  var schemaEntity = useEntity(schema);
  var data = filteredDataset || datasetEntity.data;
  var query = datasetEntity === null || datasetEntity === void 0 ? void 0 : datasetEntity.query;
  var isElastic = !isEmpty(query);
  var invalidData = !schemaEntity.schema || !datasetEntity.data; // TODO: report errors to Sentry

  if (isElastic) return null;
  if (invalidData) return null;
  return _jsx(VariantTable, _objectSpread(_objectSpread({}, props), {}, {
    schema: schemaEntity.schema,
    data: data
  }));
};

export default PT;
//# sourceMappingURL=index.js.map